import { ElxMessageBarButton, IElxMessageBarButtonProps } from '@elixir/components';
import React from 'react';

export const EHMessageBarButton = (props: IElxMessageBarButtonProps): JSX.Element => {
  return <ElxMessageBarButton {...props} />;
};
